<template>
  <div class="w-container">
    <h1>
      <strong>{{ $t("home.testimonials") }}</strong>
    </h1>
    <div class="row testimonial-wrapper">
      <div
        v-for="testimonial in testimonials.slice(start, end)"
        v-bind:data="testimonial"
        v-bind:key="testimonial.id"
        class="w-col w-col-6 w-col-small-12 w-col-tiny-12 testimonial"
      >
        <div class="quote-mark"><img :src="quotes" /></div>
        <div class="text">{{ testimonial.text }}</div>
        <div class="author">{{ testimonial.author }}</div>
      </div>
    </div>
    <div class="controls">
      <font-awesome-icon
        icon="chevron-left"
        class="control"
        v-on:click="movePrev"
        :class="{ enabled: hasPrev() }"
      />
      <span class="control-separator"></span>
      <font-awesome-icon
        icon="chevron-right"
        class="control"
        v-on:click="moveNext"
        :class="{ enabled: hasNext() }"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      testimonials: [],
      start: 0,
      end: 0,
      step: 0,
      quotes: require("../../assets/images/qoute.svg")
    };
  },
  mounted() {
    this.$http
      .get("testimonial/")
      .then(response => (this.testimonials = response.data));
    setInterval(() => {}, 3000);
    this.handleSize();
  },
  created() {
    window.addEventListener("resize", this.resizeHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeHandler);
  },
  methods: {
    moveNext: function() {
      if (this.hasNext()) {
        this.start += this.step;
        this.end += this.step;
      }
    },
    movePrev: function() {
      if (this.hasPrev()) {
        this.start -= this.step;
        this.end -= this.step;
      }
    },
    hasNext: function() {
      return this.end < this.testimonials.length;
    },
    hasPrev: function() {
      return this.start;
    },
    resizeHandler: function() {
      this.handleSize();
    },
    handleSize: function() {
      this.step = this.$mq === "lg" || this.$mq === "md" ? 2 : 1;
      this.end = this.start + this.step;
    }
  },
  name: "Testimonials"
};
</script>

<style scoped>
h1 {
  color: #19242c;
  margin: 10vh 0;
  text-align: center;
  text-transform: uppercase;
  font-size: 3.2em;
  overflow: hidden;
}

.testimonial-wrapper {
  flex-wrap: nowrap;
  overflow: hidden;
  margin: 15px;
}

.testimonial {
  border: 1px solid #ddd;
  padding: 0;
  margin: 7px;
  width: calc(50% - 14px);
}

.text {
  margin: 30px 100px 30px 90px;
  flex-grow: 1;
  height: calc(7 * 1.4em);
  color: #7c7979;
  font-size: 1.4em;
  line-height: 1.4em;
  font-weight: 300;
  overflow: hidden;
}

.quote-mark {
  margin: 35px 100px 0 90px;
  width: 60px;
}

.text,
.quote-mark {
  color: #999;
}

.author {
  border-left: #031726 solid 4px;
  padding: 20px 100px 20px 87px;
  margin-bottom: 30px;
  color: #031726;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 1.2em;
}

@media (max-width: 767px) {
  h1 {
    font-size: 2.5em;
  }

  .testimonial {
    width: calc(100% - 14px);
  }

  .text {
    margin: 15px;
    height: auto;
    font-size: 1.1em;
  }

  .quote-mark {
    margin: 12px 30px 0 35px;
    width: 30px;
  }

  .author {
    padding: 15px;
  }
}

.controls {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 40px 0 60px;
}

.controls .control {
  border: 3px solid #eee;
  border-radius: 50px;
  padding: 5px;
  color: #eee;
  height: 50px;
  width: 50px;
}

.controls .control.enabled {
  border-color: #516b81;
  color: #516b81;
}

.control-separator {
  width: 10%;
  height: 2px;
  background: #eee;
}
</style>
